'use strict';

var PriceRecommendationServicesAnalysisSelectDirection = function PriceRecommendationServicesAnalysisSelectDirection() {
  return {
    restrict: 'E',
    template: require('../templates/price-recommendation-services-analysis-direction-select.html'),
    replace: true,
    scope: {
      onDirectionFilter: '='
    },
    link: function link(scope) {
      var deregisterFilterDirectionWatch;
      scope.filterDirection = 'both';
      scope.$on('chart:services:selectedService', function () {
        unbindWatches();
        scope.filterDirection = 'both';
        registerWatches();
      });
      registerWatches();
      function unbindWatches() {
        deregisterFilterDirectionWatch();
      }
      function registerWatches() {
        deregisterFilterDirectionWatch = scope.$watch('filterDirection', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.onDirectionFilter(newValue);
          }
        });
      }
    }
  };
};
PriceRecommendationServicesAnalysisSelectDirection.$inject = [];
module.exports = PriceRecommendationServicesAnalysisSelectDirection;